module.exports = __webpack_public_path__ + "93b58496.svg";